export const DEEPLINK_DONT_EXIST = 'deeplink-dont-exist';
export const PARTNER_CONNECTION_FAILED = 'partner-connection-failed';
export const PARTNER_LINKING_ERROR = 'partner-linking-error';
export const DEFAULT_NOT_FOUND = 'not-found';
